<template>
  <div class="gNovel-Inner">
    <template v-for="(item, index) in novelList">
      <router-link
        :key="index"
        class="gNovel-Card fc-gray-8"
        :class="`gNovel-Card-screen${screenType}`"
        :to="{
          name: 'gallery-detail',
          params: { itemId: item.shouhinId },
        }"
      >
        <!-- ノベルタイトル -->
        <div class="gNovel-Card_Header">
          <!-- ノベルアイコン -->
          <div class="gNovel-Card_Icon">
            <BaseIcon :itemId="galleryIconSelect(item)" />
          </div>

          <div class="gNovel-Card_TitleBox">
            <!-- タイトル -->
            <div class="gNovel-Card_Title">{{ item.shouhinTitle }}</div>

            <div class="gNovel-Card_Name">
              <!-- 発注キャラクター -->
              <!-- <span class="secondTitle">{{ item.fullName }}</span> -->
              <!-- <span class="px-1" v-if="item.fullName && item.creatorName">/</span> -->
              <!-- クリエイター情報 -->
              <v-icon v-if="item.creatorName" small class="mr-1 mb-1"
                >menu_book</v-icon
              >
              <router-link
                v-if="screenType == 1"
                :to="{
                  name: 'creator-detail',
                  params: { creatorKbn: 3, creatorId: item.creatorId },
                }"
                class="font-weight-bold sw-Link-primary"
                >{{ item.creatorName }}</router-link
              >
              <span v-else>{{ item.creatorName }}</span>
            </div>

            <div class="gNovel-Card_Item fs-xs fc-gray-6">
              <!-- 商品区分名 -->
              <router-link
                v-if="screenType == 1"
                class="sw-Link-primary"
                :to="{
                  name: 'portalSearchResult-noWord',
                  params: { type: 'novel' },
                  query: { shouhinKbn: item.shouhinKbn },
                }"
              >
                {{ item.shouhinmei }}
              </router-link>
              <span v-else>{{ item.shouhinKbnName }}</span>
              <!-- ノベルテーマ -->
              <span v-if="item.worldThemeId">
                <span class="px-1">|</span>
                <router-link
                  class="sw-Link-primary"
                  :to="{
                    name: 'portalSearchResult',
                    params: {
                      type: 'novel',
                      keyword: item.themeTitle,
                    },
                  }"
                >
                  {{ item.themeTitle }}</router-link
                >
              </span>
            </div>
          </div>
        </div>

        <div class="gNovel-Card_Body">
          <div class="gNovel-Card_Intro">
            <!-- ノベル冒頭 -->
            <NovelPicker
              :shouhinNaiyou="item.shouhinNaiyou ? item.shouhinNaiyou : item.textThumb"
            />
          </div>

          <div class="gNovel-Card_Footer pt-1">
            <div class="gNovel-Card_Deadline">
              <!-- 納品日 -->
              <DateFormat :date="item.nouhinDate" :type="'3'" />
            </div>
            <!-- TODO:ふぇ〜実装時に表示 -->
            <!-- <div class="gNovel-Card_Count gNovel-Card_Count-post"> -->
            <!-- 評価数 -->
            <!-- <v-icon small>message</v-icon>
                {{ item.hyoukasuuShouhin }}
              </div> -->
          </div>
        </div>
      </router-link>
    </template>

    <div
      v-for="(n, i) in 4"
      :key="`spacer${i}`"
      class="gNovel-Card gNovel-Card-spacer"
    ></div>
  </div>
</template>

<script>
import DateFormat from "@/components/DateFormat";
import mixin from "@/mixins/mixin";
import NovelPicker from "@/components/NovelPicker.vue";

export default {
  name: "GalleryNovelList",
  components: {
    NovelPicker,
    DateFormat,
  },
  props: {
    novelList: {
      mode: Array,
      required: true,
    },
    // 0：デフォルト、1:検索結果
    screenType: {
      mode: Number,
      required: false,
      default: 0,
    },
  },

  methods: {
    addLike() {
      this.$emit("addLike");
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/sass/import.scss";

.gNovel {
  &-Inner {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -16px;
  }

  &-Card {
    position: relative;
    z-index: $z-content;
    flex-grow: 1;
    width: 100%;
    padding: 0 16px;
    margin: 24px 0 16px;
    cursor: pointer;

    @include media($sm) {
      width: (100%/2);
      min-width: 320px;
      margin-top: 16px;
      margin-bottom: 24px;
    }

    @include media($md) {
      width: (100%/3);
    }

    @include media($lg) {
      width: (100%/5);
    }

    &::after {
      position: absolute;
      right: 0;
      bottom: -16px;
      display: inline-block;
      width: 100%;
      height: 1px;
      content: "";
      background-color: var(--c-border);
      transform: scaleX(0.9);
    }

    &:hover::before {
      position: absolute;
      top: -16px;
      right: 8px;
      bottom: -8px;
      left: 8px;
      z-index: -1;
      display: block;
      content: "";
      background-color: var(--gray-1);
      border-radius: 4px;
      @include media($sm) {
        right: 0;
        left: 0;
      }
    }

    &_LinkBox {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: $z-nav;
      display: block;
    }

    &_Header {
      display: flex;
    }

    &_Bottom {
      position: absolute;
      bottom: -48px;
    }

    &_Icon {
      flex-shrink: 0;
      width: 50px;
      height: 50px;
      margin-right: 8px;
    }

    &_TitleBox {
      flex-shrink: 1;
      min-width: 0;
    }

    &_Title {
      @include ellipsis;
      font-size: $fs-m;
      font-weight: bold;
      line-height: 1.25;
    }

    &_Name {
      @include ellipsis;

      font-size: $fs-xs;
      font-weight: bold;
      line-height: 1;
      color: var(--gray-6);
    }

    &_Item {
      @include ellipsis;
      line-height: 1;
    }

    &_Intro {
      @include clamp(2);
      @include textBox($fs: $fs-xs, $pd: 0);

      padding-top: 4px;
      line-height: 1.2;
      color: var(--gray-8);
    }

    &_Footer {
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-size: $fs-xs;
      color: var(--gray-6);
    }

    &_Deadline {
      flex-grow: 2;
      text-align: right;
    }
  }

  &-Card-spacer {
    height: 0;
    margin: 0;

    &::after {
      content: none;
    }

    &:hover::before {
      content: none;
    }
  }
}
</style>
